import { render, staticRenderFns } from "./Overwatch-Result.vue?vue&type=template&id=5bff56a3&scoped=true"
import script from "./Overwatch-Result.vue?vue&type=script&lang=js"
export * from "./Overwatch-Result.vue?vue&type=script&lang=js"
import style0 from "./Overwatch-Result.vue?vue&type=style&index=0&id=5bff56a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff56a3",
  null
  
)

export default component.exports